import React from 'react'
import { useLocation } from 'react-router-dom'

import BankInnerPageEligibility from './BankInnerPageEligibility';
export default function BankInnerPage() {
  const location = useLocation();
  const state = location.state;
  console.log("state", state);

  return (
    <>
    <section
    className="services-area bg-white mt-120 pb-20 wow fadeInUp"
    style={{ display: "flex", flexDirection: "row" }}
  >
    <div className="container">
      <div className="section-title mb-45">
      <h2 className="wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>Learn our recruitment process</h2>
                    <p className="wow fadeInUp mb-20" data-wow-delay="0.3s" style={{ visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp" }}>Recruitment is a process of finding and attracting the
                        potential resources for filling up the
                        vacant positions in an organization. It sources the candidates with the abilities and attitude,
                        which are required for achieving the objectives of an organization.</p>
        <div className="table-responsive">

          

         
              
              <table className="table table-borderless mb-0">
              <thead>
              <tr style={{ backgroundColor: "whitesmoke"}}>
                                    <th className="text-center" scope="col"  >
                      <h5 style={{ fontSize: "80%" }}>{"Bank".toUpperCase()}</h5>
                    </th>
                    <th className="text-center" scope="col"  style={{minWidth:"300px"}} >
                      <h5 style={{ fontSize: "80%" }}>{'Processing Fee'.toUpperCase()}</h5>
                    </th>
                    <th className="text-center" scope="col"   style={{minWidth:"300px"}}>
                      <h5 style={{ fontSize: "80%" }}>{"Tenure".toUpperCase()}</h5>
                    </th>
                    <th className="text-center" scope="col"  style={{minWidth:"300px"}} >
                      <h5 style={{ fontSize: "80%",minWidth:"100%" }}>{"Loan Amount".toUpperCase()}</h5>
                    </th>
                
                </tr>
                
                  </thead>
                  <tbody>
                 
                    <tr>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  <img src={state.bankImage} style={{width:"45px"}} alt={state.bankName} />  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {state.processingFee.toUpperCase()}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {state.tenure.toUpperCase()}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {state.loanAmount.toUpperCase()}  </td>
                 
                    </tr>
                    
             
                  </tbody>

                  </table>
      
      
        </div>
      </div>
    </div>
  </section>
  <BankInnerPageEligibility data ={state}/>
  </>
  )
}
